import { jsx } from 'react/jsx-runtime';
import { createElement } from 'react';
import { fontQueryParams } from './fonts.es.js';
export { fontQueryParams, pbFontFamily, pbFontWeight } from './fonts.es.js';
import { Helmet } from 'react-helmet';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const landingLinks = [
  {
    rel: "preconnect",
    href: "https://fonts.googleapis.com"
  },
  {
    rel: "preconnect",
    href: "https://fonts.gstatic.com",
    crossOrigin: "anonymous"
  },
  {
    rel: "stylesheet",
    href: `https://fonts.googleapis.com/css2?${fontQueryParams}&display=swap`
  },
  {
    rel: "stylesheet",
    href: "https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css"
  }
];
const LandingLinks = () => /* @__PURE__ */ jsx(Helmet, {
  children: landingLinks.map((link, index) => /* @__PURE__ */ createElement("link", __spreadProps(__spreadValues({}, link), {
    key: index
  })))
});
const publicBffUrl = {
  local: "http://localhost:8081",
  dev: "https://public-builder-bff.dev.tekoapis.net",
  stag: "https://public-builder-bff.stag.tekoapis.net",
  production: "https://public-bff.tempi.vn",
  "test-1": "https://public-builder-bff.test-1.tekoapis.net",
  internal: "http://public-bff-api.page-management"
};

export { LandingLinks, landingLinks, publicBffUrl };
